module.exports = __webpack_public_path__ + "img/DSC_2679-xs.9401447b.png";